



















































































































































































































import {Component, Mixins} from 'vue-property-decorator';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
@Component({
               components: {TextInput, CommonPromptDialog, CommonButton, IconButton},
               mixins: [DialogEventsMixin, SelectDialogMixin]
           })
export default class WhoddDialog extends Mixins(DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin) {
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showWhoddSelectDialog', () => {
                this.show();
            });

        this.$modal.getEventBus().$on('hideWhoddSelectDialog', () => this.close());
    }

    public show() {
        this.visible = true;
    }

    public close() {
        this.visible = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showWhoddSelectDialog');
        this.$modal.getEventBus().$off('hideWhoddSelectDialog');
    }
}
